/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable global-require */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { useEffect } from 'react';
import { Layout, Tag, Popover } from 'antd';

import { useDispatch, useSelector } from 'react-redux';
import TimezoneSelect from 'react-timezone-select';
import {
  NAV_STYLE_DRAWER, NAV_STYLE_FIXED, NAV_STYLE_MINI_SIDEBAR, TAB_SIZE,
} from '../../constants/ThemeSetting';
import { setTimeZone, toggleCollapsedSideNav } from '../../redux/actions';
import UserInfo from "../../components/UserInfo";
import { fetchMerchantAccounts, getUserWallets } from "../../redux/actions/Data";

const { Header } = Layout;

const Topbar = () => {
  const dispatch = useDispatch();
  const { navStyle, timezone } = useSelector(({ settings }) => settings);
  const { navCollapsed, width } = useSelector(({ common }) => common);
  // const activeMerchant = useSelector(({ data }) => data.activeMerchant);
  const { authUser } = useSelector(({ auth }) => auth);
  const {
    data: merchantAccounts,
    loading: loadingMerchants
  } = useSelector(({ data }) => data.merchantAccounts);

  // const isPremiumUser = authUser &&
  //   (
  //     authUser.pricing_plan === 'suite' ||
  //     authUser.paid_accounting
  //   );
  // const hasMoreThanOneMerchant = activeMerchant && merchantAccounts.length > 0;
  // const isNotPSPUser = authUser && authUser.role.name !== 'PSP';

  // useEffect(() => {
  //   if (authUser && activeMerchant && Object.keys(activeMerchant).length) {
  //     const data = {
  //       user: authUser._id,
  //       merchant: activeMerchant._id,
  //     };
  //     dispatch(getUserWallets(data));
  //   }
  // }, [dispatch, activeMerchant]);

  useEffect(() => {
    dispatch(fetchMerchantAccounts());
  }, [dispatch]);

  const handleTimezoneChange = (value) => {
    dispatch(setTimeZone(value));
  };

  // const ActiveMerchant = () => (activeMerchant && Object.keys(activeMerchant).length > 0 ? (
  //   <span className="active-merchant-account">
  //     {activeMerchant.name}
  //   </span>
  // ) : '');

  return (
    <Header>
      {navStyle === NAV_STYLE_DRAWER
        || ((navStyle === NAV_STYLE_FIXED || navStyle === NAV_STYLE_MINI_SIDEBAR) && width < TAB_SIZE)
        ? (
          <div className="gx-linebar gx-mr-3">
            <i
              className="gx-icon-btn icon icon-menu"
              onClick={() => {
                dispatch(toggleCollapsedSideNav(!navCollapsed));
              }}
            />
          </div>
        ) : null}
      <ul className="gx-header-notifications gx-ml-auto">
        {/* <li className="gx-notify gx-notify-search gx-d-inline-block gx-d-lg-none">
          {
            process.env.REACT_APP_ENVIRONMENT === Environments.PRODUCTION
              ? <>
                <Tag color="green">LIVE</Tag>
              </>
              : (
                <>
                  <Tag color="blue">{process.env.REACT_APP_ENVIRONMENT.toUpperCase()}</Tag>
                </>
              )
          }
        </li> */}
        <li className="gx-timezone">
          <TimezoneSelect className="gx-mr-3" value={timezone} onChange={handleTimezoneChange} />
        </li>
        {/* <Auxiliary>
          {isNotPSPUser
            && (
              <li className="gx-notify">
                <Popover
                  overlayClassName="gx-popover-horizantal"
                  placement="bottomRight"
                  content={<MerchantAccounts />}
                  trigger="click"
                >
                  <span className="gx-pointer gx-d-block">
                    <i className="icon icon-apps" />
                  </span>
                </Popover>
              </li>
            )}
          <li className="gx-notify">
            <Popover
              overlayClassName="gx-popover-horizantal"
              placement="bottomRight"
              content={<MerchantAccounts />}
              trigger="click"
            >
              <span className="gx-pointer gx-d-block">
                <i className="icon icon-apps" />
              </span>
            </Popover>
          </li>
        </Auxiliary> */}


        <li className="gx-user-nav">
          <UserInfo />
        </li>
      </ul>
    </Header>
  );
};

export default Topbar;
